import { FC, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { Legend, type LegendItem } from '@components';
import { useTrans } from '@libs/i18n';
import { LightbulbIcon, PencilSimpleIcon, ProhibitIcon } from '@phosphor-icons/react';

/**
 * Explains the two per-field actions on the review screen before the user has
 * to pick one. Each pill mirrors the action as it appears on the field cards.
 * Read-only — it never gates or alters the review flow.
 */
export const ReviewLegend: FC = observer(() => {
  const { t } = useTrans();

  const items: LegendItem[] = useMemo(
    () => [
      {
        id: 'reject',
        icon: <ProhibitIcon size={12} weight="bold" />,
        color: 'error.main',
        backgroundColor: 'red.100',
        borderColor: 'red.200',
        label: t('app.documentHub.review.legend.reject.label'),
        description: t('app.documentHub.review.legend.reject.description'),
      },
      {
        id: 'addManually',
        icon: <PencilSimpleIcon size={12} weight="bold" />,
        color: 'blue.700',
        backgroundColor: 'blue.100',
        borderColor: 'blue.300',
        label: t('app.documentHub.review.legend.addManually.label'),
        description: t('app.documentHub.review.legend.addManually.description'),
      },
    ],
    [t],
  );

  return (
    <Legend
      title={t('app.documentHub.review.legend.title')}
      titleIcon={<LightbulbIcon size={10} weight="fill" />}
      items={items}
      direction="row"
    />
  );
});
